import { useMemo } from 'react';
import type { ReactElement } from 'react';
import type { Control } from 'react-hook-form';
import { useController } from 'react-hook-form';
import { FileUploadItemPreview } from '../file-upload-item-preview/FileUploadItemPreview.ctrl';
import { FileStatus } from '@ingenico/react-ui/file-handler';
import type { FileWithStatus } from '@ingenico/react-ui/file-handler';
import type { EditResourceFormValues } from '../resources-list/ResourcesList.model';
import styles from './EditResourceFileField.module.scss';

export interface EditResourceFileFieldProps {
  readonly control: Control<EditResourceFormValues>;
}

export function EditResourceFileField({ control }: EditResourceFileFieldProps): ReactElement {
  const { field } = useController({ control, name: 'file' });
  const file = useMemo<FileWithStatus>(
    () => ({
      size: field.value?.sizeBytes ?? 0,
      file: new File([], field.value?.filename ?? '', { type: field.value?.mimeType ?? '' }),
      hash: field.value?.filename ?? '',
      index: 0,
      name: field.value?.filename ?? '',
      status: FileStatus.UPLOADED,
    }),
    [field.value],
  );
  return <FileUploadItemPreview isReadonly file={file} componentsClassNames={{ container: styles.container }} />;
}
